export const AFFILIATE_API = process.env.REACT_APP_AFFILIATE_API
export default null
